

















































import {Component, Prop, Watch} from 'vue-property-decorator';
import BaseComponent from '@/core/components/BaseComponent';
import AuthService from '@/services/AuthService';
import bus from '@/main';

@Component({
    components: {

    }
})
export default class SystemBarMenu extends BaseComponent {

    // Bindings to parent

    // Bindings to view
    public isReady = false;
    public userInitials = '';
    public userFullName = '';
    public showMenu = false;

    public mounted() {
        bus.$on('MeRefreshed', () => {
            this.renderView();
        });
        this.renderView();
    }

    public beforeDestroy() {
        super.beforeDestroy();
    }

    private renderView() {
        this.userInitials = this.currentUser?.initials ?? '';
        this.userFullName = this.currentUser?.name ?? '';
        this.isReady = true;
    }

    public onMyProfileBtnClicked() {
        bus.$emit(`userEdit`, this.currentUser!.id);
    }

    public onLogoutBtnClicked() {
        AuthService.handleLogout();
    }

}
